var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enps-rating-distribution",attrs:{"title":_vm.tooltip}},_vm._l((_vm.values),function(value){return _c('span',{key:value,staticClass:"enps-rating-distribution__segment",style:({ width: _vm.widthPercent(value) + '%', backgroundColor: _vm.colors[value] })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }